export function getDefaultDialogSelectionPath(pluginId, currentFont) {
    if (!currentFont?.path) {
        return null;
    }
    return currentFont.sourcePlugin?.getId?.() === pluginId
        ? currentFont.path
        : null;
}
export function isOpenDialogConfirmEnabled(selectedPathIsOpenableFont) {
    return selectedPathIsOpenableFont;
}
export function shouldOpenFileOnDialogDoubleClick(mode, isFont) {
    return mode === 'open' && isFont;
}
export function getFileDialogPrimaryAction(mode, selectedPath, selectedPathIsOpenableFont, pluginId, currentFont) {
    if (mode === 'save-as') {
        return 'save';
    }
    if (!selectedPath || !selectedPathIsOpenableFont) {
        return 'none';
    }
    if (currentFont?.path === selectedPath &&
        currentFont.sourcePlugin?.getId?.() === pluginId) {
        return 'close';
    }
    return 'open';
}
export function getFileDialogHeaderActions(pluginId, supportsNewFolder, showsManualRefreshButton) {
    return {
        showsUploadButtons: pluginId === 'memory',
        showsNewFolderButton: supportsNewFolder,
        showsRefreshButton: showsManualRefreshButton
    };
}
export function getFileDialogSaveWarningPresentation(warningState, isSaveAsDialog) {
    const visible = Boolean(warningState?.visible && isSaveAsDialog);
    return {
        visible,
        blocksSave: Boolean(visible && !warningState?.canSave),
        title: visible ? warningState.title : '',
        label: visible ? warningState.label : '',
        icon: visible ? warningState.icon : '',
        tone: visible ? warningState.tone : ''
    };
}
export function getFileDialogRefreshStatus(showsManualRefreshButton, timestamp) {
    if (!showsManualRefreshButton) {
        return { visible: false, text: '' };
    }
    const timestampText = timestamp
        ? new Date(timestamp).toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        })
        : 'Not refreshed yet';
    return { visible: true, text: `Last refreshed ${timestampText}` };
}
